import { Action, MetaReducer, createReducer } from '@ngrx/store';
import { HttpStateHandler } from '@shared/utils/classes/http-state-handler';
import { produceOn, transferStateMetaReducer } from '@shared/utils/functions/store.function';
import { HttpState } from '@shared/utils/models/http.model';
import { EventInvitation } from '@features/event-invitation/utils/models/event-invitation.model';
import { EventInvitationActions, EventInvitationResetActions } from '../actions/event-invitation.actions';

export const eventInvitationFeatureKey = 'eventInvitation';

export interface State {
  hash: string | null;
  invitation: EventInvitation | null;
  httpState: HttpState;
}

export const initialState: State = {
  hash: null,
  invitation: null,
  httpState: HttpStateHandler.initialState,
};

export const eventInvitationReducer = createReducer(
  initialState,
  produceOn(EventInvitationActions.getEventInvitation, (draft, action) => {
    draft.hash = action.hash;
    draft.invitation = initialState.invitation;
    draft.httpState = HttpStateHandler.loading(draft.httpState, action);
  }),
  produceOn(EventInvitationActions.getEventInvitationSuccess, (draft, action) => {
    draft.invitation = action.invitation;
    draft.httpState = HttpStateHandler.success(draft.httpState, action);
  }),
  produceOn(EventInvitationActions.getEventInvitationFailure, (draft, action) => {
    draft.httpState = HttpStateHandler.error(draft.httpState, action);
  }),
  produceOn(EventInvitationResetActions.cancelEventInvitationActionsSuccess, (draft) => {
    draft.httpState = HttpStateHandler.initialState;
  }),
  produceOn(EventInvitationResetActions.resetEventInvitation, (draft) => {
    draft.hash = initialState.hash;
    draft.invitation = initialState.invitation;
    draft.httpState = initialState.httpState;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return eventInvitationReducer(state, action);
}

export const metaReducers: MetaReducer<State>[] = [
  transferStateMetaReducer(eventInvitationFeatureKey, initialState, false),
];
